import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP: {},
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: { //查询
        queryGroupList(context, payload) {
            payload.type = 'mqinfo/queryGroupList'
            return D.select({
                ...payload
            })

        },
        //查询
        searchMqInfo(context, payload) {
            payload.type = 'mqinfo/searchMqInfo'
            return D.select({
                ...payload
            })

        },   //查询
        searchMqInfoAndResendMessage(context, payload) {
            payload.type = 'mqinfo/searchMqInfoAndResendMessage'
            return D.select({
                ...payload
            })

        }, searchMqInfoCount(context, payload) {
            payload.type = 'mqinfo/searchMqInfoCount'
            return D.select({
                ...payload
            })

        }, resendMessage(context, payload) {
            payload.type = 'mqinfo/resendMessage'
            return D.select({
                ...payload
            })
        }, selectResendLogs(context, payload) {
            payload.type = 'mqinfo/selectResendLogs'
            return D.select({
                ...payload
            })
        }, queryResendProgress(context, payload) {
            payload.type = 'mqinfo/queryResendProgress'
            return D.select({
                ...payload
            })
        }, selectResendLogsDetailOne(context, payload) {
            payload.type = 'mqinfo/selectResendLogsDetailOne'
            return D.select({
                ...payload
            })
        }, searchTopics(context, payload) {
            payload.type = 'mqinfo/searchTopics'
            return D.select({
                ...payload
            })
        },queryDomainMap(context, payload) {
            payload.type = 'mqinfo/queryDomainMap'
            return D.select({
                ...payload
            })
        },

    }
}
